export default {
  getBonusAdjustmentList: state => {
    return state.bonusAdjustmentList
  },
}
